import { render, staticRenderFns } from "./SafetyObservationPriorityEdit.vue?vue&type=template&id=d76124ce"
import script from "./SafetyObservationPriorityEdit.vue?vue&type=script&lang=js"
export * from "./SafetyObservationPriorityEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports